import { Component, Input } from "@angular/core";
import { IonicPage } from "ionic-angular";
import { ReferralsServiceProvider } from "providers/patient-charts/referrals-service";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { BasePage } from "../../base-page";

@IonicPage({
  name: "patient-eprescribe",
  segment: "patient-eprescribe/:patientId",
})
@Component({
  selector: "patient-eprescribe",
  templateUrl: "patient-eprescribe.html",
})
export class PatientEPrescribePage extends BasePage {
  @Input() destinationPage: string;

  pageType: string = "";

  constructor(
    public referralsService: ReferralsServiceProvider,
    public stateData: StateManagementService,
    state: StateManagementService
  ) {
    super(state);

    this.referralsService.ACTIVE_TAB_NAME = "patient-eprescribe";
    if (this.referralsService.PATIENT_STATUS) {
      this.pageType = this.referralsService.PATIENT_STATUS;
    }
  }
  ionViewDidLoad() {
    this.stateData.setAssessmentType("Patient Profile");
    this.stateData.setSectionId("Meds");
  }
}



// WEBPACK FOOTER //
// ./src/pages/patient-chart/patient-eprescribe/patient-eprescribe.ts